module.exports = __webpack_public_path__ + "images/花筑院子全景_04-2.jpg?v=76e58cfe";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu4/花筑院子全景_04-2.jpg
 ** module id = 73
 ** module chunks = 1 2
 **/